app.component("patientFileUploader", {
    templateUrl: "app/src/js/components/patientFileUploader/patientFileUploader.html",
    controller: "patientFileUploaderController",
    bindings: {
        filesCallback: "&",
    },
});

app.controller("patientFileUploaderController", [
    "$scope",
    "Session",
    "PatientAPI",
    "CurrentPatient",
    "$modal",
    "$uibModal",
    "FileUploader",
    "ENV",
    "UploadFileAPI",
    "$filter",
    "$sce",
    "FILE_TYPES",
    "$timeout",
    "patientDocumentService",
    "$element",
    function ($scope, Session, PatientAPI, CurrentPatient, $modal, $uibModal, FileUploader, ENV, UploadFileAPI, $filter, $sce, FILE_TYPES, $timeout, patientDocumentService, $element) {
        $scope.API = UploadFileAPI;
        $scope.uploadedFileList = [];
        $scope.queueSize = 0;

        $scope.IMAGE_PDF_OPTIONS = FILE_TYPES.image;
        $scope.WORD_OPTIONS = FILE_TYPES.word;
        $scope.VIDEO_OPTIONS = FILE_TYPES.video;

        $scope.isAiAnalysisChecked = true;
        $scope.newFileItem = undefined;
        $scope.fileOptions = [];
        $scope.fileType = null;

        // --- INTERNAL UTILITIES FOR REFERRAL VALIDATION MULTIPART DATA ---
        function transformDate(value) {
            if (!value) return '';
            const array = value.split('/');
            return array[2] + '-' + array[1] + '-' + array[0];
        }

        function getOfficialPractitionerIdFromPractitioner(item) {
            if (!item) return '';
            for (let idObj of item) {
                if (idObj.system === 'https://standards.digital.health.nz/ns/hpi-person-id' && idObj.use === 'Official') {
                    return idObj.value;
                }
            }
            return '';
        }

        function getOfficialOrganisationIdFromOrganisation(item) {
            if (!item) return '';
            for (let idObj of item) {
                if (idObj.system === 'https://standards.digital.health.nz/ns/hpi-organisation-id' && idObj.use === 'Official') {
                    return idObj.value;
                }
            }
            return '';
        }

        function getOfficialLocationIdFromLocation(item) {
            if (!item) return '';
            for (let idObj of item) {
                if (idObj.system === 'https://standards.digital.health.nz/ns/hpi-facility-id' && idObj.use === 'Official') {
                    return idObj.value;
                }
            }
            return '';
        }

        // --- DRY DELEGATION TO SERVICE WITH STRING EXTRACATION SAFEGUARDS ---
        const getFileIdentifier = (item) => {
            if (!item) return '';
            return typeof item === 'string' ? item : (item.name || item.type || '');
        };

        $scope.isImageFile = function (item) { return patientDocumentService.isImageFile(getFileIdentifier(item)); };
        $scope.isPdfFile = function (item) { return patientDocumentService.isPdfFile(getFileIdentifier(item)); };
        $scope.isWordFile = function (item) { return patientDocumentService.isWordFile(getFileIdentifier(item)); };
        $scope.isVideoFile = function (item) { return patientDocumentService.isVideoFile(getFileIdentifier(item)); };

        $scope.closeFileUploadErrorModal = function () {
            $scope.failedFilesList = [];
            $scope.alertMessage = null;
            if ($scope.modalInstance) $scope.modalInstance.hide();
            if ($scope.errorModal) $scope.errorModal.hide();
        };

        $scope.downloadFile = function (fileId, fileName) {
            $scope.API.isProcessing = true;
            $scope.API.downloadFile(CurrentPatient.patient.id, fileId).then(function (resp) {
                openFile(resp.data, fileName);
            }).finally(function () {
                $scope.API.isProcessing = false;
            });
        };

        $scope.deleteFileConfirm = function () {
            $scope.errorModal.hide();
            $scope.API.isProcessing = true;
            $scope.API.deleteFile(CurrentPatient.patient.id, $scope.deleteFileItem).finally(function () {
                $scope.API.isProcessing = false;
                $scope.deleteFileItem = null;
            });
        };

        $scope.clearFileDeleteConfirm = function () {
            $scope.deleteFileItem = null;
            $scope.errorModal.hide();
        };

        $scope.deleteFile = function (fileId, fileName) {
            if ($scope.deleteFileItem == null) {
                $scope.deleteFileItem = fileId;
                $scope.errorModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.file-upload-delete.tpl.html",
                    show: true,
                    backdrop: "static",
                    title: fileName ? `Delete ${fileName}` : "Delete File",
                    onHide: function () {
                        $scope.deleteFileItem = null;
                    }
                });
            }
        };

        function openFile(data, filename) {
            var blob = new Blob([data]);
            if (typeof window.navigator.msSaveBlob !== "undefined") {
                window.navigator.msSaveBlob(blob, filename);
            } else {
                var blobURL = window.URL.createObjectURL(blob);
                var tempLink = document.createElement("a");
                tempLink.style.display = "none";
                tempLink.href = blobURL;
                tempLink.setAttribute("download", filename);
                if (typeof tempLink.download === "undefined") {
                    tempLink.setAttribute("target", "_blank");
                }
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(blobURL);
                $scope.displaySpinner = false;
            }
        }

        // Scoped to this component: the document table behind the modal has an input with the same id,
        // and document.getElementById found that one instead of ours.
        function clearFileInput() {
            const input = $element[0].querySelector("#uploadCaptureInputFile");
            if (input) input.value = "";
        }

        var uploader = $scope.uploader = new FileUploader({ queueLimit: 5 });

        uploader.filters.push({
            name: 'fileFilter',
            fn: function (item) {
                return !patientDocumentService.isFileTooBig(item) &&
                    patientDocumentService.isFileNameValid(item) &&
                    patientDocumentService.isFileTypeSupported(item);
            }
        });

        $scope.closePdfViewer = function () {
            if ($scope.pdfViewerModal) $scope.pdfViewerModal.hide();
            if ($scope.pdfUrl) {
                URL.revokeObjectURL($scope.pdfUrl);
                $scope.pdfUrl = undefined;
            }
        };

        $scope.closeWordViewer = function () {
            if ($scope.wordViewerModal) $scope.wordViewerModal.hide();
        };

        $scope.previewPDF = function (item) {
            $scope.pdfUrl = URL.createObjectURL(item);
            $scope.scroll = 0;
            $scope.pdfViewerModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.pdf-viewer.tpl.html",
                show: true,
                title: "DOCUMENT PREVIEW",
                backdrop: true,
                keyboard: false,
            });
        };

        $scope.previewWord = function (item) {
            $scope.wordViewerModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.word-viewer.tpl.html",
                show: true,
                title: "DOCUMENT PREVIEW",
                backdrop: true,
                keyboard: false,
            });
            $timeout(() => { patientDocumentService.handleFileSelect(item, item.type.includes('text/plain')); }, 500);
        };

        $scope.previewVideo = function (item) {
            $scope.videoUrl = URL.createObjectURL(item);
            $scope.config = patientDocumentService.getVideoConfig($scope.videoUrl);
            $scope.videoViewerModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.video-viewer.tpl.html",
                show: true,
                title: "VIDEO PREVIEW",
                backdrop: true,
                keyboard: false,
            });
        };

        $scope.closeVideoViewer = function () {
            if ($scope.videoViewerModal) $scope.videoViewerModal.hide();
            if ($scope.videoUrl) {
                URL.revokeObjectURL($scope.videoUrl);
                $scope.videoUrl = undefined;
            }
        };

        $scope.uploadAll = function () {
            $scope.uploader.uploadAll();
        };

        $scope.$watch("uploader.queue.length", function (newValue) {
            $scope.$ctrl.filesCallback({ unsaved: newValue > 0 });
        }, true);

        let queueTimeout;
        $scope.failedFilesList = [];
        uploader.onWhenAddingFileFailed = function (item, filter, options) {
            var alertMessage = 'File could not be added.';

            // Check exactly which validation failed to give an accurate error
            if (patientDocumentService.isFileTooBig(item)) {
                alertMessage = 'Maximum file size is 200MB.';
            } else if (!patientDocumentService.isFileTypeSupported(item)) {
                alertMessage = 'Unsupported format. Please use standard clinical images/documents.';
            } else if (!patientDocumentService.isFileNameValid(item)) {
                alertMessage = 'File name must only contain alphanumeric, hyphen, underscore, spaces, and dot characters.';
            } else if ($scope.uploader.queue.length >= 5) {
                alertMessage = 'Maximum queue size reached.';
            }

            $scope.failedFilesList.push({ fileName: item.name, alertMessage: alertMessage });

            if (queueTimeout) $timeout.cancel(queueTimeout);
            queueTimeout = $timeout(function () {
                if ($scope.failedFilesList.length > 0 && !onAfterAllProcessing) {
                    onAfterAllProcessing = true;
                    $scope.addedFilesList.push({
                        template: {
                            templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html",
                            scope: $scope,
                            title: "File(s) cannot be added",
                            show: true,
                        },
                    });
                    processQueue($scope.addedFilesList);
                }
            }, 150);

            clearFileInput();
        };

        $scope.fileItem_fileType = null;
        $scope.addedFilesList = [];

        uploader.onAfterAddingFile = function (fileItem) {
            $scope.newFileItem = fileItem;
            $scope.fileOptions = patientDocumentService.getFileOptions(fileItem._file.name, FILE_TYPES);

            fileItem.security_level = "GLOBAL";
            fileItem.operative_eye = "OU";
            fileItem.comment = '';
            fileItem.dateOfConsultation = $filter("date")(new Date(), "dd/MM/yyyy");
            fileItem.url = ENV.API + `/api/files/patient/${CurrentPatient.patient.id}`;
            fileItem.headers = {
                Authorization: "Bearer " + Session.token,
                "X-PRACTICE-ID": `${Session.practice.id}`,
            };

            // Remove OS-appended characters like " 1" or " (1)" before sending to backend
            let cleanName = fileItem.file.name.replace(/(\.[a-zA-Z0-9]{2,5})[\s\(\)-]*\d*[\s\(\)-]*$/, '$1');

            let lastDotIndex = cleanName.lastIndexOf('.');
            if (lastDotIndex !== -1) {
                $scope.newFileItem.file.name = cleanName.substring(0, lastDotIndex);
                $scope.newFileItem.file.suffix = cleanName.substring(lastDotIndex + 1);
            } else {
                $scope.newFileItem.file.name = cleanName;
                $scope.newFileItem.file.suffix = "";
            }

            if ($scope.isAiAnalysisChecked) {
                fileItem.fileType = 'AI_ANALYSIS';
                $scope.fileItem_fileType = { id: 'AI_ANALYSIS', name: 'AI Analysis' };
            } else {
                if ($scope.fileOptions && $scope.fileOptions.length > 0) {
                    fileItem.fileType = $scope.fileOptions[0].id;
                    $scope.fileItem_fileType = { id: $scope.fileOptions[0].id, name: $scope.fileOptions[0].name };
                }

                $scope.addedFilesList.push({
                    template: {
                        templateUrl: "app/src/views/templates/modal.file-upload-details.tpl.html",
                        controller: "fileDetailController",
                        backdrop: "static",
                        scope: $scope,
                        title: `File Details`,
                        show: true,
                    },
                    data: {
                        newFileItem: $scope.newFileItem,
                        fileType: $scope.fileItem_fileType,
                        fileOptions: $scope.fileOptions
                    }
                });
            }
        };

        function processQueue(queue) {
            if (!queue || queue.length === 0) {
                onAfterAllProcessing = false;
                return;
            }

            var currentItem = queue.shift();
            var modalConfig = currentItem.template;
            modalConfig.resolve = currentItem.resolve || {};

            if (currentItem.data) {
                for (const [key, value] of Object.entries(currentItem.data)) {
                    modalConfig.resolve[key] = () => { return value; };
                }
            }

            modalConfig.onHide = () => {
                let fileItem = currentItem.data?.newFileItem;
                if (fileItem && fileItem.file.name && fileItem.file.suffix) {
                    fileItem.file.name = `${fileItem.file.name}.${fileItem.file.suffix}`;
                }
                processQueue(queue);
            };

            $scope.modalInstance = $modal(modalConfig);
        }

        var onAfterAllProcessing = false;
        uploader.onAfterAddingAll = function () {
            clearFileInput();

            if (onAfterAllProcessing) return;
            onAfterAllProcessing = true;

            if ($scope.failedFilesList.length > 0) {
                $scope.addedFilesList.push({
                    template: {
                        templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html",
                        scope: $scope,
                        title: "File(s) cannot be added",
                        show: true,
                    },
                });
            }
            processQueue($scope.addedFilesList);
        };

        uploader.onBeforeUploadItem = function (item) {
            $scope.errorModal = null;

            // Re-attach the file extension if the AI Analysis bypass stripped it
            let finalName = item.file.name;
            if (item.file.suffix && !finalName.endsWith(`.${item.file.suffix}`)) {
                finalName = `${finalName}.${item.file.suffix}`;
                item.file.name = finalName;
            }

            item.formData = [
                { 'fileName': finalName }, // Just send the properly formatted name with the extension
                { 'confidential': false },
                { 'comment': item.comment || '' },
                { 'securityLevel': item.security_level },
                { 'eye': item.operative_eye },
                { 'fileType': item.fileType },
                { 'dateOfConsultation': patientDocumentService.convertDateOfConsultation(item.dateOfConsultation) },
            ];

            // CONSOLIDATED REQUIREMENT: Re-append form payload schema structured rules for raw manual Referral submissions
            if (item.fileType === "REFERRAL") {
                const referralData = {
                    referredToUserId: item.referredToUserId ? item.referredToUserId.toString() : null,
                    referredToPracticeId: item.referredToPracticeId ? item.referredToPracticeId.toString() : Session.practice.id.toString(),
                    dateOfReferralUTC: item.dateOfReferral ? moment(transformDate(item.dateOfReferral)).utc().toISOString() : moment().utc().toISOString(),
                    referredByPractitionerId: getOfficialPractitionerIdFromPractitioner(item.practitioner),
                    referredByOrganisationId: getOfficialOrganisationIdFromOrganisation(item.org),
                    referredByLocationId: getOfficialLocationIdFromLocation(item.referredByLocationId),
                    reason: item.referral_reason,
                    urgency: item.referral_urgency
                };

                // The referring provider the referral was issued by, and how long it runs for, sent
                // in the shape the referral stores them so the PatientReferral generated from this
                // upload can be claimed against. Only asked for in AU, and only sent when the
                // uploader filled at least one in - an empty object would record a referral as
                // carrying provider details it does not have.
                if (item.referral_provider_id || item.referral_period) {
                    referralData.providerDetails = {
                        providerId: item.referral_provider_id || null,
                        referralPeriod: item.referral_period || null,
                        // Carried only against the period that has a length to state.
                        referralPeriodMonths: item.referral_period === 'NON_STANDARD'
                            ? (Number(item.referral_period_months) || null) : null
                    };
                }

                item.formData.push({ referralData: JSON.stringify(referralData) });
            }
        };

        // The files this run stored, in the order they landed. Handed back when the run finishes so
        // the document list knows exactly which files to follow while they are analysed, rather
        // than having to work it out from the list.
        let uploadedFileIds = [];

        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            if (status >= 200 && status < 300 && response && response.file_id) {
                uploadedFileIds.push(response.file_id);
            }
        };

        uploader.onErrorItem = function (fileItem, response, status, headers) {
            fileItem.errorMessage = response?.message || response?.error || "Unknown server error.";
        };

        uploader.onCompleteAll = function () {
            const failureItems = $scope.uploader.queue.filter(t => t.isError);
            const successCount = $scope.uploader.queue.filter(t => t.isSuccess).length;

            if (failureItems.length > 0) {
                let errorDetails = failureItems.map(item => `- ${item.file.name}: ${item.errorMessage}`).join('\n');
                let successContext = successCount > 0 ? `(${successCount} other files uploaded successfully.)\n\n` : '';

                $scope.alertMessage = `${successContext}The following files failed to upload:\n${errorDetails}`;

                $scope.errorModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html",
                    show: true,
                    title: "File(s) cannot be uploaded",
                });

                // Leave only the failed items in the queue, marked not-uploaded so "Upload all" can
                // retry them - the uploader flags a failed item as uploaded, which left it stuck.
                failureItems.forEach(function (item) { item.isUploaded = false; });
                $scope.uploader.queue = failureItems;
            } else {
                $scope.uploader.clearQueue();

                // Handed over as the run's own list, so a later run cannot carry these again.
                const storedFileIds = uploadedFileIds;
                uploadedFileIds = [];

                $scope.successModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
                    show: true,
                    title: "Success",
                    content: "Document(s) uploaded successfully.",
                    onHide: function () { $scope.$ctrl.filesCallback({ close: true, uploadedFileIds: storedFileIds }); },
                });
            }
        };
    }
]);